import { requestServer } from '$lib/servers.svelte'
import { invalidateServerToken } from '$lib/auth.svelte'

export async function getOperation(server: any, id: string) {
  try {
    const { data, status } = await requestServer(
      server,
      'get',
      `api/v1/operations/${id}`,
      null
    )
    if (status == 401) throw { response: { status: 401 } }
    return data
  } catch (error) {
    if (error?.response?.status == 401) {
      invalidateServerToken(server.uid)
      return
    }
    console.log(error)
    throw error
  }
}
